import { render, staticRenderFns } from "./ClassAdd.vue?vue&type=template&id=fcd6d8ae&scoped=true&"
import script from "./ClassAdd.vue?vue&type=script&lang=js&"
export * from "./ClassAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClassAdd.vue?vue&type=style&index=0&id=fcd6d8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd6d8ae",
  null
  
)

export default component.exports